import SharedSelectInput from '../shared/SelectInput';

import {
  addMissingMandatoryField,
  removeMissingMandatoryField,
  addRemark,
  removeRemark,
  updateRemark,
  addFile,
  removeFile,
} from 'reducers/autoPersonalFormReducer';

import type { MessageProps } from '../shared/Message/Message.types';

interface AutoSelectInputProps {
  section: number;
  label: string;
  options: { value: string; label: string }[];
  value: string;
  message?: Omit<MessageProps, 'section'> & { section?: number };
  onChange?: (event: any) => void;
  required?: boolean;
  disabled?: boolean;
  [x: string]: any;
}

const AutoSelectInput = (props: AutoSelectInputProps) => {
  const formActions = {
    addMissingMandatoryField,
    removeMissingMandatoryField,
    addRemark,
    removeRemark,
    updateRemark,
    addFile,
    removeFile,
  };

  return (
    <SharedSelectInput
      {...props}
      formStateKey="autoPersonalForm"
      formActions={formActions}
    />
  );
};

export default AutoSelectInput;
